const namespaceLoaders = {
  ru: {
    account_transfer: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/account_transfer.yml'),
    accounts_marketplace: () =>
      import(
        /* webpackChunkName: "i18n-ru-marketplace" */ 'i18n/getuniq/ru/accounts_marketplace.yml'
      ),
    advertisers: () =>
      import(/* webpackChunkName: "i18n-ru-advertisers" */ 'i18n/getuniq/ru/advertisers.yml'),
    agency: () => import(/* webpackChunkName: "i18n-ru-agency" */ 'i18n/getuniq/ru/agency.yml'),
    audits: () =>
      import(/* webpackChunkName: "i18n-ru-recommendations" */ 'i18n/getuniq/ru/audits.yml'),
    auth: () => import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/getuniq/ru/auth.yml'),
    autoreplenish: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/autoreplenish.yml'),
    banners: () => import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/banners.yml'),
    bank_cards: () => import(/* webpackChunkName: "i18n-ru-bank-cards" */ 'i18n/getuniq/ru/bank_cards.yml'),
    benchmarks: () =>
      import(/* webpackChunkName: "i18n-ru-recommendations" */ 'i18n/getuniq/ru/benchmarks.yml'),
    billing: () => import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/getuniq/ru/billing.yml'),
    campaigns_editor: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/campaigns_editor.yml'),
    common: () => import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/getuniq/ru/common.yml'),
    cookie_banner: () =>
      import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/getuniq/ru/cookie-banner.yml'),
    countries: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/countries.yml'),
    faq: () => import(/* webpackChunkName: "i18n-ru-faq" */ 'i18n/getuniq/ru/faq.yml'),
    finance: () => import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/getuniq/ru/finance.yml'),
    form_errors: () =>
      import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/getuniq/ru/form_errors.yml'),
    industries: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/industries.yml'),
    invoices: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/getuniq/ru/invoices.yml'),
    media_planner: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/media_planner.yml'),
    lead_manager: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/lead_manager.yml'),
    navigation: () =>
      import(/* webpackChunkName: "i18n-ru-navigation" */ 'i18n/getuniq/ru/navigation/index.js'),
    oauth: () => import(/* webpackChunkName: "i18n-ru-oauth" */ 'i18n/getuniq/ru/oauth.yml'),
    onboarding: () =>
      import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/getuniq/ru/onboarding.yml'),
    partners_program: () =>
      import(/* webpackChunkName: "i18n-ru-partners" */ 'i18n/getuniq/ru/partners_program.yml'),
    payment_order: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/getuniq/ru/payment_order.yml'),
    payment_profiles: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/getuniq/ru/payment_profiles.yml'),
    promised_payment: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/getuniq/ru/promised_payment.yml'),
    pulse: () => import(/* webpackChunkName: "i18n-ru-statistics" */ 'i18n/getuniq/ru/pulse.yml'),
    recommendations: () =>
      import(
        /* webpackChunkName: "i18n-ru-recommendations" */ 'i18n/getuniq/ru/recommendations.yml'
      ),
    referral: () =>
      import(/* webpackChunkName: "i18n-ru-referral" */ 'i18n/getuniq/ru/referral.yml'),
    reward_calculator: () =>
      import(/* webpackChunkName: "i18n-ru-partners" */ 'i18n/getuniq/ru/reward_calculator.yml'),
    services: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/getuniq/ru/services.yml'),
    statistics: () =>
      import(/* webpackChunkName: "i18n-ru-statistics" */ 'i18n/getuniq/ru/statistics.yml'),
    tickets: () => import(/* webpackChunkName: "i18n-ru-tickets" */ 'i18n/getuniq/ru/tickets.yml'),
    user: () => import(/* webpackChunkName: "i18n-ru-user" */ 'i18n/getuniq/ru/user.yml'),
    wallets: () => import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/getuniq/ru/wallets.yml'),
  },
  en: {
    account_transfer: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/account_transfer.yml'),
    accounts_marketplace: () =>
      import(
        /* webpackChunkName: "i18n-en-marketplace" */ 'i18n/getuniq/en/accounts_marketplace.yml'
      ),
    advertisers: () =>
      import(/* webpackChunkName: "i18n-en-advertisers" */ 'i18n/getuniq/en/advertisers.yml'),
    agency: () => import(/* webpackChunkName: "i18n-en-agency" */ 'i18n/getuniq/en/agency.yml'),
    audits: () =>
      import(/* webpackChunkName: "i18n-en-recommendations" */ 'i18n/getuniq/en/audits.yml'),
    auth: () => import(/* webpackChunkName: "i18n-en-core" */ 'i18n/getuniq/en/auth.yml'),
    autoreplenish: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/autoreplenish.yml'),
    banners: () => import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/banners.yml'),
    bank_cards: () => import(/* webpackChunkName: "i18n-en-bank-cards" */ 'i18n/getuniq/en/bank_cards.yml'),
    benchmarks: () =>
      import(/* webpackChunkName: "i18n-en-recommendations" */ 'i18n/getuniq/en/benchmarks.yml'),
    billing: () => import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/getuniq/en/billing.yml'),
    campaigns_editor: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/campaigns_editor.yml'),
    common: () => import(/* webpackChunkName: "i18n-en-core" */ 'i18n/getuniq/en/common.yml'),
    cookie_banner: () =>
      import(/* webpackChunkName: "i18n-en-core" */ 'i18n/getuniq/en/cookie-banner.yml'),
    countries: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/countries.yml'),
    faq: () => import(/* webpackChunkName: "i18n-en-faq" */ 'i18n/getuniq/en/faq.yml'),
    finance: () => import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/getuniq/en/finance.yml'),
    form_errors: () =>
      import(/* webpackChunkName: "i18n-en-core" */ 'i18n/getuniq/en/form_errors.yml'),
    industries: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/industries.yml'),
    invoices: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/getuniq/en/invoices.yml'),
    media_planner: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/media_planner.yml'),
    lead_manager: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/lead_manager.yml'),
    navigation: () =>
      import(/* webpackChunkName: "i18n-en-navigation" */ 'i18n/getuniq/en/navigation/index.js'),
    oauth: () => import(/* webpackChunkName: "i18n-en-oauth" */ 'i18n/getuniq/en/oauth.yml'),
    onboarding: () =>
      import(/* webpackChunkName: "i18n-en-core" */ 'i18n/getuniq/en/onboarding.yml'),
    partners_program: () =>
      import(/* webpackChunkName: "i18n-en-partners" */ 'i18n/getuniq/en/partners_program.yml'),
    payment_order: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/getuniq/en/payment_order.yml'),
    payment_profiles: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/getuniq/en/payment_profiles.yml'),
    promised_payment: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/getuniq/en/promised_payment.yml'),
    pulse: () => import(/* webpackChunkName: "i18n-en-statistics" */ 'i18n/getuniq/en/pulse.yml'),
    recommendations: () =>
      import(
        /* webpackChunkName: "i18n-en-recommendations" */ 'i18n/getuniq/en/recommendations.yml'
      ),
    referral: () =>
      import(/* webpackChunkName: "i18n-en-referral" */ 'i18n/getuniq/en/referral.yml'),
    reward_calculator: () =>
      import(/* webpackChunkName: "i18n-en-partners" */ 'i18n/getuniq/en/reward_calculator.yml'),
    services: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/getuniq/en/services.yml'),
    statistics: () =>
      import(/* webpackChunkName: "i18n-en-statistics" */ 'i18n/getuniq/en/statistics.yml'),
    tickets: () => import(/* webpackChunkName: "i18n-en-tickets" */ 'i18n/getuniq/en/tickets.yml'),
    user: () => import(/* webpackChunkName: "i18n-en-user" */ 'i18n/getuniq/en/user.yml'),
    wallets: () => import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/getuniq/en/wallets.yml'),
  },
}

export default namespaceLoaders
